<template>
    <div>
        <div class="wrap">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ title }}
                            <div class="clear"></div>
                        </div>
                        <div class="table_wrap">
                            <div class="c_table_wrap table_search_wrap">
                                <table>
                                    <colgroup>
                                        <col width="200px;">
                                        <col width="">
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <td class="c_t_title">개인정보</td>
                                        <td>
                                            <div class="search">
                                                <el-select
                                                    v-model="searchOption"
                                                    placeholder="Select"
                                                    class="table_s_select"
                                                >
                                                    <el-option
                                                        v-for="(item, index) in searchOptions"
                                                        :key="index"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input class="table_s_input"
                                                          v-model="tableSearch"
                                                          size=""
                                                          prefix-icon="el-icon-search"
                                                          placeholder="검색어를 입력해주세요."
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="c_t_title">기간</td>
                                        <td>
                                            <div class="date">
                                                <el-button @click="changeFilterDate('today')" type="info">오늘</el-button>
                                                <el-button @click="changeFilterDate('week')" type="info">7일</el-button>
                                                <el-button @click="changeFilterDate('month')" type="info">한달</el-button>
                                                <el-button @click="changeFilterDate('year')" type="info">1년</el-button>
                                                <el-button @click="changeFilterDate('')" type="info">전체</el-button>
                                                <el-date-picker
                                                    v-model="filterDate"
                                                    type="daterange"
                                                    range-separator="~"
                                                    value-format="yyyy-MM-dd"
                                                    start-placeholder="시작날짜"
                                                    end-placeholder="끝 날짜"
                                                >
                                                </el-date-picker>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="c_t_title">회원성별</td>
                                        <td>
                                            <div>
                                                <el-select
                                                    v-model="filterGender"
                                                    placeholder="Select"
                                                    class="table_s_select"
                                                >
                                                    <el-option
                                                        :label="'전체'"
                                                        :value="''"
                                                    ></el-option>
                                                    <el-option
                                                        :label="'남자'"
                                                        :value="0"
                                                    ></el-option>
                                                    <el-option
                                                        :label="'여자'"
                                                        :value="1"
                                                    ></el-option>
                                                </el-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="c_t_title">회원등급</td>
                                        <td>
                                            <div>
                                                <el-select
                                                    v-model="filterStatus"
                                                    placeholder="Select"
                                                    class="table_s_select"
                                                >
                                                    <el-option
                                                        :label="'전체'"
                                                        :value="''"
                                                    ></el-option>
                                                    <el-option
                                                        :label="'일반회원'"
                                                        :value="0"
                                                    ></el-option>
                                                    <el-option
                                                        :label="'테스터'"
                                                        :value="1"
                                                    ></el-option>
                                                </el-select>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_search search_btn_wrap text_center">
                                <el-button type="primary" class="search_btn" @click="getList">검색</el-button>
                            </div>
                            <div>
                                {{ListLocalLength}}건이 조회됨
                            </div>
                            <div class="table_search row has_bc">
                                <el-row>
                                    <el-col :span="12">
                                    </el-col>
                                    <el-col class="text_right"  :span="12">
                                        <excel-down class="mr10" :list="ApiData" :header="excelHeader" :filterVal="excelfilterVal" :fileName="'회원관리목록'" :size="'small'"></excel-down>
                                        <el-select
                                            v-model="pageRow"
                                        >
                                            <el-option
                                                v-for="row in pageRows"
                                                :key="row"
                                                :label="`${row}개 씩보기`"
                                                :value="row"
                                            ></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-table
                                :data="ListData"
                                style="width: 100%"
                                empty-text="데이터가 없습니다."
                                @cell-click="cellClick"
                                @selection-change="tableSelectChnage"
                                @sort-change="sortChange"
                                v-loading="tableLoading"
                            >
                                <el-table-column
                                    class="table_no"
                                    type="index"
                                    label="#"
                                    width="70"
                                    class-name="num"
                                    :index="tableIndex"
                                >
                                </el-table-column>

                                <el-table-column
                                    v-for="(header, index) in tableHeader"
                                    :key="index"
                                    :label = header.label
                                    :width = header.width
                                    :sortable="header.sortable"
                                    :class-name="`${header.class}`"
                                    :cell="header.prop"
                                    :prop="header.sortProp"
                                >
                                    <template slot-scope="scope">
                                        <div
                                            :class="{'has_cursor': header.hasClickable}"
                                        >
                                            <div class="table_img" v-if="header.prop === 'img'">
                                                <div class="table_img" v-if="scope.row.Writer.File"
                                                     :style="`background-image: url(${scope.row.Writer.File.thumb_url})`"></div>
                                            </div>
                                            <div class="table_file_wrap"
                                                 v-else-if="header.prop === 'file'"
                                            >
                                                <div class="table_file" v-if="scope.row.File">
                                                    <a
                                                        v-for="(file, index) in scope.row.File"
                                                        :key="index"
                                                        :href="file.thumb_url"
                                                        target="blank"
                                                    >
                                                        {{file.org_name}} <i class="el-icon-download"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <span
                                                v-else
                                                v-html="$_.result(scope.row, header.prop) ? $_.result(scope.row, header.prop) : isNaN($_.result(scope.row, header.prop)) || $_.result(scope.row, header.prop) === null || $_.result(scope.row, header.prop) === '' ? '-' : $_.result(scope.row, header.prop)"
                                            >
                      </span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagnation_wrap">
                                <el-pagination
                                    v-show="ListLocalLength > 0"
                                    :page-size = pageRow
                                    :pager-count = 11
                                    layout="prev, pager, next"
                                    :current-page.sync = page
                                    :page-sizes="[10, 20, 30]"
                                    :total="ListLocalLength"
                                >
                                </el-pagination>
                            </div>
                            <div class="table_search row has_bc">
                                <el-row>
                                    <el-col :span="12">
                                    </el-col>
                                    <el-col :span="12" class="text_right">
                                        <el-select
                                            v-model="pageRow"
                                        >
                                            <el-option
                                                v-for="row in pageRows"
                                                :key="row"
                                                :label="`${row}개 씩보기`"
                                                :value="row"
                                            ></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from '@/mixins/util';
import List from '@/mixins/List';
import localStorage from '@/mixins/localStorage'
import ExcelDown from "@/components/ExcelDown";

let params = {};
export default {
    name: 'Log',
    components: {
        ExcelDown
    },
    mixins: [ List, localStorage ],
    data() {
        return{
            title: this.$route.meta.title,
            searchOption: 'ni',
            searchOptions: [
                {
                    label: '닉네임',
                    value: 'ni'
                },
                {
                    label: '아이디',
                    value: 'mid'
                },
                {
                    label: '이름',
                    value: 'na'
                },
            ],
            tableSearch: '',
            filterDate: '',
            filterStatus: '',
            filterGender: '',
            tableHeader: [
                {
                    label: '아이디',
                    prop: 'mb_id',
                    sortable: false,
                    class: 'text_center',
                },
                {
                    label: '이름',
                    prop: 'mb_name',
                    sortable: false,
                    class: 'text_center',
                },
                {
                    label: '닉네임',
                    prop: 'mb_nick',
                    sortable: false,
                    class: 'text_center',
                    sortProp: 'mb_nick',
                },
                {
                    label: '작성글',
                    prop: 'writeCnt',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'writeCnt',
                },
                {
                    label: '받은댓글',
                    prop: 'getComment',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'getComment',
                },
                {
                    label: '받은좋아요',
                    prop: 'getLike',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'getLike',
                },
                {
                    label: '신규팔로워',
                    prop: 'getFollow',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'getFollow',
                },
                {
                    label: '신규 스타일저장',
                    prop: 'getSave',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'getSave',
                },
                {
                    label: '남긴좋아요',
                    prop: 'writeLike',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'writeLike',
                },
                {
                    label: '남긴댓글',
                    prop: 'writeComment',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'writeComment',
                },
                {
                    label: '남긴저장',
                    prop: 'writeSave',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'writeSave',
                },
                {
                    label: '남긴팔로우',
                    prop: 'writeFollow',
                    sortable: true,
                    class: 'text_center',
                    sortProp: 'writeFollow',
                },
            ],
            excelHeader: ['아이디', '이름', '닉네임', '작성글', '받은댓글', '받은좋아요', '신규팔로워', '신규 스타일저장', '남긴좋아요', '남긴댓글', '남긴저장', '남긴팔로우'],
            excelfilterVal: ['mb_id', 'mb_name', 'mb_nick', 'writeCnt', 'getComment', 'getLike', 'getFollow', 'getSave', 'writeLike', 'writeComment', 'writeSave', 'writeFollow'],
            tableoption: true,
            pageRows: [10, 30, 50],
        }
    },
    beforeRouteLeave(to, from, next){
        if(to.path === "/auth" && this.$localStorage.get('token')){
            next(false);
        }else{
            return next();
        }
    },
    mounted() {
        this.getList();
    },
    computed: {
    },
    methods: {
        initData(){
            this.tableData = [];
            this.page = 1;
            this.tableLoading = true;
            this.selectRow = [];
        },
        getList() {
            this.tableLoading = true;
            params = {
                // ip: 1,
                // sp: this.pageRow,
                // page : this.page,
                // m_type : 'out'
            }
            if(!util.isEmpty(this.filterDate) && this.filterDate.length > 0) {
                params.s_date = this.filterDate[0];
                params.e_date = this.filterDate[1];
            }
            if(this.filterStatus !== ''){
                params.iste = this.filterStatus;
            }
            if(this.filterGender !== ''){
                params.se = this.filterGender;
            }
            if(this.tableSearch != '') {
                params[this.searchOption]= this.tableSearch;
            }
            this.$api.$member.getMemberLog(params).then(res => res.Data.Result).then(res => {
                /*if(res.Info.Type < 0) {
                    return false;
                }*/
                let list = res.List;
                this.ApiData = list;
                this.oriApiData = list.slice();
                this.tableLoading = false;
            })
        },
        changeFilterDate(date) {
            if(date === 'today')  {
                this.filterDate = [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')];
            }else if(date === 'week') {
                this.filterDate = [this.$moment().add(-1, 'w').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            }else if(date === 'month') {
                this.filterDate = [this.$moment().add(-1, 'M').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            }else if(date === 'year') {
                this.filterDate = [this.$moment().add(-1, 'y').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
            }else if(date === '') {
                this.filterDate = null;
            }
        },
        sortChange({ column, prop, order }) {
            this.page = 1;
            let sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : "";
            this.setSort(prop, sortOrder)
        },
        goDetail(index, row) {
            this.MoveChild("/custom/qa/detail/" + row.qa_idx)
        },
        tableIndex(index) {
            console.log(index);
            return this.ApiData.length - index - (this.page - 1) * this.pageRow;
        },

    }
}
</script>
